// extracted by mini-css-extract-plugin
module.exports = {"image":"_3xU_l8","title":"_2IvGI4","section":"_2zqWWl","description":"hshuPK"};